import { render, staticRenderFns } from "./CurvaSConcluir.vue?vue&type=template&id=0724e6e5&scoped=true&"
import script from "./CurvaSConcluir.vue?vue&type=script&lang=js&"
export * from "./CurvaSConcluir.vue?vue&type=script&lang=js&"
import style0 from "./CurvaSConcluir.vue?vue&type=style&index=0&id=0724e6e5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0724e6e5",
  null
  
)

export default component.exports